import React, { useMemo } from 'react'
import FlipMove from 'react-flip-move'
import PropTypes from 'prop-types'
import FlipMoveTypeName from '@v4/components/common/FlipMoveTypeName'

const SortHandler = ({ children, defaultOrder = null, direction = null, parentRef }) => {
	const childArray = useMemo(() => React.Children.toArray(children), [children])

	const renderOrder = useMemo(() => {
		const currArray = defaultOrder || childArray.map((_, index) => index)

		return direction ? [...currArray].sort((a, b) => (direction === 'desc' ? b - a : a - b)) : currArray
	}, [defaultOrder, childArray, direction])

	return (
		<FlipMove disableAllAnimations={!parentRef} parentRef={parentRef} duration={300} typeName={FlipMoveTypeName}>
			{renderOrder.map(index => childArray[index] || null)}
		</FlipMove>
	)
}

SortHandler.propTypes = {
	children: PropTypes.node.isRequired,
	defaultOrder: PropTypes.arrayOf(PropTypes.number),
	direction: PropTypes.oneOf(['asc', 'desc']),
	parentRef: PropTypes.object,
}

export default SortHandler
